import { Component, ViewChild, NgZone} from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { DetailPage } from '../pages/details/detail';
import {ContentstackService} from './contentstack';
//import {Observable} from 'rxjs/Rx';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = HomePage;
  categories:any = [];

  pages: Array<{title: string, component: any}>;

  constructor(public zone: NgZone, public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, private ContentstackService:ContentstackService) {
    this.initializeApp();
    var Query = ContentstackService.Stack.ContentType("category").Query();
                Query
               .only('title')
               .toJSON()
               .find()
               .spread((entries, schema, count) => {
                   this.zone.run(() =>{
                     this.categories = entries;
                   });
               },(err) => {
                   console.log("err",err);
               });
  
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(category) {
    this.nav.setRoot(HomePage,{
      item: category || null
    });
  }
  openDetailPage(category){
    this.nav.setRoot(HomePage,{
      item: category
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts